<template>
  <div class="wrapper">
    <div class="form-group">
      <div class="col-sm-9">
        <input type="file" id="csv_file" name="csv_file" @change="fileSelect">
        <Button label="Importera" icon="pi pi-upload" @click="loadCSV" />
        <Button label="Spara" icon="pi pi-plus" @click="save" />
      </div>
    </div>
    <TabView>
      <TabPanel v-for="priceList in FERALCO_BASE_PRICES" :header="priceList.name" :active="priceList.active === 1" :key="priceList.id">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Skapa ny prislista med namn</span>
          <InputText type="text" v-model="newName" placeholder="Namn" />
          <span class="p-inputgroup-addon">Uppräkning med</span>
          <InputText type="number" step=0.01 v-model="newPercent" />
          <span class="p-inputgroup-addon">%</span>
          <Button label="Skapa" :disabled="newName === '' || newPercent === null" @click="createNew" />
        </div>
        <Accordion>
          <AccordionTab header="Basprislista">
            <FeralcoPricesList :data="priceList.data" />
          </AccordionTab>
          <AccordionTab header="Artikelprislista">
            <FeralcoArticlePriceList :data="priceList.data" />
          </AccordionTab>
        </Accordion>
      </TabPanel>
      <TabPanel :header="data.name" :active="true" v-if="data !== null">
        <Accordion>
          <AccordionTab header="Basprislista">
            <FeralcoPricesList :data="data.data" />
          </AccordionTab>
          <AccordionTab header="Artikelprislista">
            <FeralcoArticlePriceList :data="data.data" />
          </AccordionTab>
        </Accordion>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>

import FileUpload from 'primevue/fileupload'
import Button from 'primevue/button'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import InputText from 'primevue/inputtext'

import Papaparse from 'papaparse'

import FeralcoPricesList from './FeralcoPricesList'
import FeralcoArticlePriceList from './FeralcoArticlePriceList'

import { mapGetters } from 'vuex'

export default {
  name: 'FeralcoPricesListAdmin',
  components: {
    FileUpload,
    Button,
    TabView,
    TabPanel,
    Accordion,
    AccordionTab,
    InputText,
    FeralcoPricesList,
    FeralcoArticlePriceList
  },
  data () {
    return {
      file: null,
      data: null,
      newPercent: null,
      newName: ''
    }
  },
  mounted () {
    this.$store.dispatch('GET_FERALCO_BASE_PRICES')
  },
  computed: {
    ...mapGetters(['FERALCO_BASE_PRICES', 'FERALCO_BASE_PRICE_CURRENT'])
  },
  methods: {
    fileSelect (event) {
      this.file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0]
    },
    loadCSV (event) {
      if (this.file === null) {
        return
      }
      Papaparse.parse(this.file, {
        complete: (results, file) => {
          this.processCSV(results.data)
        }
      })
    },
    processCSV (data) {
      const firstRow = data.shift()
      const cols = [{
        field: 'km',
        header: firstRow[0]
      }, {
        field: 'first',
        header: firstRow[1]
      }, {
        field: 'second',
        header: firstRow[2]
      }, {
        field: 'third',
        header: firstRow[3]
      }, {
        field: 'fourth',
        header: firstRow[4]
      }, {
        field: 'fifth',
        header: firstRow[5]
      }, {
        field: 'sixth',
        header: firstRow[6]
      }]
      const name = firstRow[7]
      let prices = data.filter(f => f.length > 7).map((d) => {
        return {
          km: d[0],
          first: d[1].replace(',', '.'),
          second: d[2].replace(',', '.'),
          third: d[3].replace(',', '.'),
          fourth: d[4].replace(',', '.'),
          fifth: d[5].replace(',', '.'),
          sixth: d[6].replace(',', '.')
        }
      })
      this.data = {
        name: name,
        active: 1,
        data: {
          cols: cols,
          rows: prices
        }
      }
    },
    async save (event) {
      await this.$store.dispatch('ADD_FERALCO_BASE_PRICE', this.data)
    },
    saveArticles (event) {

    },
    calculateNewPrice (rows, percent) {
      const mul = 1 + (percent / 100)
      return rows.map(row => {
        return {
          km: row.km,
          first: (parseFloat(row.first) * mul).toFixed(10),
          second: (parseFloat(row.second) * mul).toFixed(10),
          third: (parseFloat(row.third) * mul).toFixed(10),
          fourth: (parseFloat(row.fourth) * mul).toFixed(10),
          fifth: (parseFloat(row.fifth) * mul).toFixed(10),
          sixth: (parseFloat(row.sixth) * mul).toFixed(10)
        }
      })
    },
    async createNew (event) {
      const currentPrice = this.FERALCO_BASE_PRICE_CURRENT()
      let newPrice = {
        name: this.newName,
        active: 0,
        data: {
          cols: currentPrice.data.cols,
          rows: this.calculateNewPrice(currentPrice.data.rows, this.newPercent)
        }
      }
      await this.$store.dispatch('ADD_FERALCO_BASE_PRICE', newPrice)
      await this.$store.dispatch('GET_FERALCO_BASE_PRICES')
      this.newPercent = 0
      this.newName = ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/FeralcoPrices/FeralcoPricesListAdmin.vue